import { fetchJsonData } from '../../../global/data/service.js'
import { showAlertBanner } from '../../../components/AlertBanner/index.js'
import { STATUS_ERROR } from '../../../components/AlertBanner/Constants.js'
import {
  ERROR_MESSAGE_TITLE,
  FUND_PERFORMANCE_ERROR_MESSAGE_TEXT,
} from './helpers/ErrorMessages.js'
import { isLocal } from '../../../global/environments/index.js'
import { encodeForURL } from '../../../global/formatters/string-formatter.js'
import modelPortfoliosFilterMock from '../../../../test/components/InvestmentProducts/mock/model-portfolios-filter.json'
import { fetcher } from './../productDetail/Helper.js'
export async function getMutualFundClassMetadata() {
  try {
    const url = `/pnp.svc/productTotals?group=Retail`

    return await fetchJsonData(url)
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_PERFORMANCE_ERROR_MESSAGE_TEXT,
    })
  }
}

export async function getEtfClassMetadata() {
  try {
    const data = {
      value: {
        classTotals: [
          {
            className: 'ETF',
            filterInfo: [
              {
                filterName: 'investorGoal',
                filterValues: [
                  {
                    code: 'Strategic Beta',
                    desc: 'Strategic Beta',
                  },
                  {
                    code: 'Thematic',
                    desc: 'Thematic',
                  },
                ],
              },
            ],
            investmentCategories: [
              {
                styleId: '22',
                categoryName: 'Domestic Equity',
              },
              {
                styleId: '25',
                categoryName: 'Global/International Equity',
              },
              {
                styleId: '1',
                categoryName: 'Sector Equity/Specialty',
              },
              {
                styleId: '26',
                categoryName: 'Taxable Fixed Income',
              },
              {
                styleId: '27',
                categoryName: 'Tax-Exempt Fixed Income',
              },
            ],
            managementStyles: [
              {
                code: 'Active',
                desc: 'Active',
              },
              {
                code: 'Indexed',
                desc: 'Indexed',
              },
            ],
          },
        ],
      },
    }

    return data
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_PERFORMANCE_ERROR_MESSAGE_TEXT,
    })
  }
}

export async function getIntervalFundData(tag, classes = '') {
  let url = `/pnp.svc/productSummary?group=interval&dataType=${tag}`
  if (classes) {
    url = url + `&className=${classes}`
  }
  return await fetcher(url)
}

export async function getMutualFundData(tag, classes) {
  try {
    const url = `/pnp.svc/productSummary?group=retail&dataType=${tag}&className=${classes}`

    return await fetchJsonData(url)
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_PERFORMANCE_ERROR_MESSAGE_TEXT,
    })
  }
}

export async function get529Data(tag, classes) {
  try {
    const url = `/pnp.svc/productSummary?group=FutureScholar529&dataType=${tag}&className=${classes}`

    return await fetchJsonData(url)
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_PERFORMANCE_ERROR_MESSAGE_TEXT,
    })
  }
}

export async function getExchangeTradedFundsData() {
  try {
    const url = `/pnp.svc/productList?group=RetailETF`

    return await fetchJsonData(url)
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_PERFORMANCE_ERROR_MESSAGE_TEXT,
    })
  }
}

export async function getExchangeTradedFundsData2(tag) {
  try {
    const url = `/pnp.svc/productSummary?group=etf&dataType=${tag}`

    const data = await fetchJsonData(url)

    // Change attribute names to make it consistent with Mutual Funds for sorting, etc
    if (tag === 'PricesAndYields') {
      const funds =
        data && data.value && data.value.etfs && data.value.etfs.priceFunds

      if (funds) {
        funds.forEach((fund) => {
          fund.popDollar = fund.marketPrice
          fund.navDollarChange = fund.premiumDiscountAmount
          fund.navPercentageChange = fund.premiumDiscountPercent
        })
      }
    }

    return data
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_PERFORMANCE_ERROR_MESSAGE_TEXT,
    })
  }
}

export async function getVariableFundsData(tag, classes) {
  try {
    const url = `/pnp.svc/productSummary?group=VariableProducts&dataType=${tag}&className=${classes}`

    return await fetchJsonData(url)
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_PERFORMANCE_ERROR_MESSAGE_TEXT,
    })
  }
}

export async function getClosedEndFundsData(tag) {
  try {
    const url = `/pnp.svc/productSummary?group=ClosedEnd&dataType=${tag}`

    return await fetchJsonData(url)
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_PERFORMANCE_ERROR_MESSAGE_TEXT,
    })
  }
}

export async function getModelPortfoliosData() {
  try {
    const url = '/pnp.svc/productSummary?group=ModelPortfolios'

    return await fetchJsonData(url)
    // return modelPortfoliosMock
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_PERFORMANCE_ERROR_MESSAGE_TEXT,
    })
  }
}

export function getModelPortfoliosFilterData() {
  try {
    return modelPortfoliosFilterMock
  } catch (err) {
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_PERFORMANCE_ERROR_MESSAGE_TEXT,
    })
  }
}

export const getDownloadFunds = ({
  type,
  selectedClass,
  selectedFilter,
  selectedDisplayBenchmark,
  selectedDisplayMorningstar,
}) => {
  let url = ''

  url += '/cmg.svc/exportsummary'
  url += '?fundGroupName=Retail'
  url += '&className=' + selectedClass.className
  url += '&fileType=' + type

  if (selectedFilter.types && selectedFilter.types.indexOf('manyStars') > -1) {
    url += '&fourandfiveStar=true'
  }

  if (
    selectedFilter.types &&
    selectedFilter.types.indexOf('multiManager') > -1
  ) {
    url += '&multiMangFilter=MM1'
  }

  if (
    selectedFilter.types &&
    selectedFilter.types.indexOf('featureFund') > -1
  ) {
    url += '&multiMangFilter=MM1'
  }

  if (selectedFilter.categories && selectedFilter.categories.length > 0) {
    url += '&invCat=' + selectedFilter.categories.join()
  } else {
    url +=
      '&invCat=' +
      selectedClass.investmentCategories
        .map((invCat) => invCat.styleId.toString())
        .join()
  }

  if (selectedFilter.goals && selectedFilter.goals.length > 0) {
    url += '&invGoalFilter=' + selectedFilter.goals.join()
  } else {
    url += '&invGoalFilter='
  }

  url += '&morningStar=false'
  url += '&priBenchMark=' + selectedDisplayBenchmark.toString()
  url += '&mornOrLipper=' + selectedDisplayMorningstar.toString()

  return url
}

export const getFullHoldings = (cusip, period) => {
  let url = '/cmg.svc/exportFullHoldings'

  if (cusip) {
    url += '?cusip=' + encodeForURL(cusip)
  }

  if (period) {
    url += '&period=' + encodeForURL(period)
  }

  return url
}

export const getDownloadCapGains = ({ type, period, cusip }) => {
  let url = isLocal() ? 'https://www.dev.columbiathreadneedleus.com' : ''

  url += '/cmg.svc/exportCapGains'
  url += '?dataType=' + encodeForURL(type)

  if (period) {
    url += '&period=' + encodeForURL(period)
  }

  if (cusip) {
    url += '&cusip=' + encodeForURL(cusip)
  }

  return url
}

export const getDownloadEtfs = ({
  type,
  selectedDisplayBenchmark,
  selectedDisplayMorningstar,
}) => {
  let url = ''

  url += '/cmg.svc/exportsummary'
  url += '?fundGroupName=etf'
  url += '&fileType=' + type
  url += '&morningStar=false'
  url += '&priBenchMark=' + selectedDisplayBenchmark.toString()
  url += '&mornOrLipper=' + selectedDisplayMorningstar.toString()

  return url
}
